import { useDispatch } from 'react-redux';
import requests from '../../../../redux/reducer/requests';
import content from '../../../../redux/reducer/content';

export default function useYearStatCallbacks() {
  const dispatch = useDispatch();

  return {
    getYearStat: () => dispatch(requests.thunks.getYearStat()),
    setYearStatActiveItem: (data) => dispatch(content.actions.setYearStatActiveItem(data)),
    resetYearStatActiveItem: () => dispatch(content.actions.resetYearStatActiveItem()),
    resetYearStat: () => dispatch(content.actions.resetYearStat()),
  };
}
